import {
  SET_BRANDED_EMAIL_TEMPLATE_OPTIONS_FOR_AUTH
} from 'zoomforth_shared_management/const/branding.js';

//// Reducer

export default (state = {}, action)=> {
  switch (action.type) {

  case SET_BRANDED_EMAIL_TEMPLATE_OPTIONS_FOR_AUTH:
    return { 
      ...state,
      brandedEmailTemplateOptionsForAuth: action.brandedEmailTemplateOptionsForAuth
    };

  default:
    return state;

  }
};

//// Selectors

export const getBrandedEmailTemplateOptionsForAuth = (state)=>
  state.brandedEmailTemplateOptionsForAuth;
